import { useCallback, useEffect } from "react";
import { useState } from "react";
import { request } from "../../httpClient";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const useTravelSet = () => {
  const travelSetReq = useCallback(async (values) => {
    console.log("values", values);
    const formatDate = (dateString) => {
      // Проверяем валидность именно в формате DD.MM.YYYY (третий параметр true включает строгую проверку)
      const d = dayjs(dateString, "DD.MM.YYYY", true);
      if (d.isValid()) {
        return d.format("YYYY-MM-DD");
      }
      return null;
    };

    // 2. Работаем с FormData через get/set
    const dateStartRaw = values.get("date_start");
    const dateEndRaw = values.get("date_end");

    if (dateStartRaw) {
      const formattedStart = formatDate(dateStartRaw);
      if (formattedStart) {
        values.set("date_start", formattedStart);
      }
    }

    if (dateEndRaw) {
      const formattedEnd = formatDate(dateEndRaw);
      if (formattedEnd) {
        values.set("date_end", formattedEnd);
      }
    }
    const result = await request({
      path: "trip/set",
      method: "POST",
      body: values,
      requestType: null,
      // body: JSON.stringify(values),
    });
    return result;
  }, []);

  return { travelSetReq };
};
